import { DealService } from '@spilca/order_ts/v1/order_web/deal_web_pb_service';
import {
  ListDealAgentResponse,
  ListDealAgentRequest
} from '@spilca/order_ts/v1/order/model_deal_pb';
import { Sorting } from '@spilca/order_ts/v1/order/common_pb';
import { createPagination, FILTER_PARAMS } from '@monorepo/helpers';
import { getGrpcPromise } from '@monorepo/grpc';

const getListDealAgent = (
  filter: any
): Promise<ListDealAgentResponse.AsObject> => {
  const { pageParam, pageSize } = filter;
  const request = new ListDealAgentRequest();

  const sort = new Sorting();
  sort.setFieldName('created_at');
  sort.setOrder(1);
  request.setSortingList([sort]);

  const pager = createPagination(
    pageParam || filter[FILTER_PARAMS.page] || 1,
    pageSize
  );

  request.setPagination(pager);

  return getGrpcPromise(DealService.ListDealAgent)(request);
};

export default getListDealAgent;
